import { Typography, Link as MuiLink } from "@mui/material"
import { ReactElement } from "react"

import { INSTALLER_LIST_APPLICATIONS_COPY_TEXT } from "../../constants/messages"
import { useScreenSize } from "../../hooks/useScreenSize"
import * as routes from "../../router/routes"

const InstallerBannerContent = (): ReactElement => {
    const { isMob } = useScreenSize()

    const fontSize = isMob ? "0.45rem" : "0.7rem"

    return (
        <Typography variant="body2" fontSize={fontSize}>
            {INSTALLER_LIST_APPLICATIONS_COPY_TEXT.replace(
                " Find out more in our FAQs.",
                ""
            )}{" "}
            Find out more in our{" "}
            <MuiLink href={routes.LEARN_MORE}>FAQs</MuiLink>.
        </Typography>
    )
}

export default InstallerBannerContent
